/**
 * How long the server keeps what it keeps, in one place. The API enforces these and the privacy page
 * (apps/web/src/lib/privacy.ts) quotes them, so the policy cannot say one thing while the code does another.
 */
export const RETENTION = {
  /** A sent verse (with its solves and reports) is deleted this many days after it was sent. */
  sentVerseDays: 30,
  /** An encrypted sync copy nobody has touched for this many days is deleted. */
  syncIdleDays: 365,
  /** Daily reminders go quiet after this many in a row that the player never answered by opening the app. */
  reminderUnansweredLimit: 7,
  /** A reminder subscription is deleted after this many delivery failures in a row. */
  reminderFailureLimit: 5,
} as const;
